/* eslint-disable react/prop-types */
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { useEffect } from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';


let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const DraggableMarker = ({ position, setPosition, reverseGeocode }) => {
  const map = useMap();

  // Sync map center when position changes
  useEffect(() => {
    map.setView(position, map.getZoom());
  }, [position, map]);

  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);
      if (reverseGeocode) reverseGeocode({ lat, lng });
    },
  });

  return (
    <Marker
      draggable
      position={position}
      eventHandlers={{
        dragend: async (e) => {
          const { lat, lng } = e.target.getLatLng();
          setPosition([lat, lng]);
          if (reverseGeocode) reverseGeocode({ lat, lng });
        },
        click(e) {
          const { lat, lng } = e.latlng;
          setPosition([lat, lng]);
          if (reverseGeocode) reverseGeocode({ lat, lng });
        },
      }}
    />
  );
};

export default function MapComponent({ position, setPosition, reverseGeocodeMutation }) {
  return (
    <MapContainer
      center={[-6.200000, 106.816666]} // Jakarta coordinates
      zoom={16}
      style={{ height: '500px', width: '100%' }}

    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <DraggableMarker
        position={position}
        setPosition={setPosition}
        reverseGeocode={reverseGeocodeMutation}
      />
    </MapContainer>
  );
}